import React from "react";
import { Card, CardBody, Col, Progress, Row } from "reactstrap";

import { ActivityReportData } from "./types";

/**
 * Two measures that deliberately ignore the selected date range: adoption is
 * all-time by definition, and stickiness is only meaningful over fixed rolling
 * windows. The agency, page and user filters still apply to both.
 */
const AdoptionAndStickiness = ({
  data,
}: {
  data: ActivityReportData | null;
}) => {
  const adoption = data?.adoption;
  const stickiness = data?.stickiness;

  return (
    <Col xxl={4}>
      <Card className="card-height-100">
        <CardBody>
          <div className="d-flex align-items-center mb-2">
            <h5 className="card-title mb-0 flex-grow-1">Adoption</h5>
            <span className="badge bg-primary-subtle text-primary fs-12">
              {adoption?.adoptionRate || 0}% of accounts used
            </span>
          </div>
          <p className="text-muted fs-13">
            Registered accounts that have ever visited a page. Not affected by
            the date range.
          </p>
          <Progress
            value={adoption?.adoptionRate || 0}
            color="primary"
            className="mb-3"
            style={{ height: "8px" }}
          />
          <Row className="text-center g-0 mb-4">
            <Col xs={4}>
              <div className="p-2 border border-dashed border-start-0">
                <h5 className="mb-1">{adoption?.registeredUsers || 0}</h5>
                <p className="text-muted mb-0 fs-12">Registered</p>
              </div>
            </Col>
            <Col xs={4}>
              <div className="p-2 border border-dashed border-start-0">
                <h5 className="mb-1 text-success">
                  {adoption?.everActiveUsers || 0}
                </h5>
                <p className="text-muted mb-0 fs-12">Ever active</p>
              </div>
            </Col>
            <Col xs={4}>
              <div className="p-2 border border-dashed border-start-0 border-end-0">
                <h5 className="mb-1 text-danger">
                  {adoption?.neverActiveUsers || 0}
                </h5>
                <p className="text-muted mb-0 fs-12">Never active</p>
              </div>
            </Col>
          </Row>

          <div className="d-flex align-items-center mb-2">
            <h5 className="card-title mb-0 flex-grow-1">Stickiness</h5>
            <span className="badge bg-info-subtle text-info fs-12">
              {stickiness?.dauOverMau || 0}% DAU/MAU
            </span>
          </div>
          <p className="text-muted fs-13">
            Share of the last 30 days&apos; users who were active today.
          </p>
          <Progress
            value={stickiness?.dauOverMau || 0}
            color="info"
            className="mb-3"
            style={{ height: "8px" }}
          />
          <Row className="text-center g-0">
            <Col xs={4}>
              <div className="p-2 border border-dashed border-start-0">
                <h5 className="mb-1">{stickiness?.dau || 0}</h5>
                <p className="text-muted mb-0 fs-12">Today</p>
              </div>
            </Col>
            <Col xs={4}>
              <div className="p-2 border border-dashed border-start-0">
                <h5 className="mb-1">{stickiness?.wau || 0}</h5>
                <p className="text-muted mb-0 fs-12">Last 7 days</p>
              </div>
            </Col>
            <Col xs={4}>
              <div className="p-2 border border-dashed border-start-0 border-end-0">
                <h5 className="mb-1">{stickiness?.mau || 0}</h5>
                <p className="text-muted mb-0 fs-12">Last 30 days</p>
              </div>
            </Col>
          </Row>
        </CardBody>
      </Card>
    </Col>
  );
};

export default AdoptionAndStickiness;
